module.exports = "/_next/static/images/pc-095fc0738c8a3a5c3e8205fcc9361de6.png";